const GLOBAL_TOKEN_VARS = [
  '--brand-primary',
  '--brand-primary-light',
  '--brand-primary-dark',
  '--brand-primary-hover',
  '--brand-secondary',
  '--brand-secondary-light',
  '--brand-secondary-bright',
  '--brand-secondary-dark',
  '--success',
  '--warning',
  '--error',
  '--info',
  '--background',
  '--foreground',
  '--card',
  '--popover',
  '--muted',
  '--accent',
  '--border',
  '--input',
  '--ring',
  '--radius',
] as const;

/** Removes inline token overrides left on :root by the design system playground. */
export function clearGlobalDesignTokenOverrides() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  for (const cssVar of GLOBAL_TOKEN_VARS) {
    root.style.removeProperty(cssVar);
  }
}
